import React from 'react';
import { motion } from 'framer-motion';
import CloseIcon from '@mui/icons-material/Close';
export function ProblemAgitation() {
  const problems = ['Mirás tutoriales sueltos y nunca entendés el proceso completo', 'No sabés qué materiales comprar ni dónde conseguirlos baratos', 'Tenés miedo de gastar plata y no vender nada', 'No sabés cuánto cobrar por tus productos', 'Querés vender por Instagram pero no sabés cómo arrancar', 'Probás manualidades que terminan siendo difíciles o poco rentables'];
  return <section className="py-10 px-4 bg-slate-50" data-id="element-193">
      <div className="max-w-4xl mx-auto" data-id="element-194">
        <div className="text-center mb-6" data-id="element-195">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3 leading-tight" data-id="element-196">
            ¿Cuánto tiempo más vas a seguir mirando ideas…{' '}
            <span className="text-red-600" data-id="element-197">sin empezar?</span>
          </h2>
          <p className="text-base text-slate-700 font-medium max-w-2xl mx-auto" data-id="element-198">
            Amás las mascotas. Te gustaría ganar dinero desde casa. Querés hacer
            algo creativo y rentable.{' '}
            <span className="font-bold" data-id="element-199">Pero seguramente te pasa esto:</span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6" data-id="element-200">
          {problems.map((problem, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-3 rounded-xl shadow-sm border border-red-100 flex items-start gap-3" data-id="element-201">
              <div className="bg-red-100 p-1 rounded-full text-red-600 shrink-0 mt-0.5" data-id="element-202">
                <CloseIcon fontSize="small" data-id="element-203" />
              </div>
              <p className="text-slate-700 font-medium" data-id="element-204">{problem}</p>
            </motion.div>)}
        </div>

        <div className="text-center bg-brand-800 text-white p-5 rounded-2xl shadow-lg" data-id="element-205">
          <p className="text-lg font-medium mb-1 opacity-90" data-id="element-206">
            No es falta de capacidad.
          </p>
          <p className="text-xl md:text-2xl font-bold mb-3" data-id="element-207">
            Es falta de un sistema claro.
          </p>
          <p className="text-brand-200 text-base font-medium" data-id="element-208">
            🐾 ¿Y si este fuera el momento de empezar algo realmente rentable?
          </p>
        </div>
      </div>
    </section>;
}